<div class="container-fluid p-0">
  <div class="topbar d-flex justify-content-between mx-1">
    <div class="d-flex align-items-center">
      <button *ngIf="currentSection > 0" (click)="previousSection()">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/94e4da27ba1b99b28b565c38ff7e7b86c50c863e69b6bac6710576d28b53d2bc?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
          alt="Profile"
          class="profile-icon"
        />
      </button>
    </div>
    <button (click)="onBack()">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/7cb02f3bafac43cfab39d23a61c0455196795a73ffc77ad66c7f8968319328e1?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
        alt="Close"
        class="close-icon"
      />
    </button>
  </div>
  <section
    style="height: 100vh"
    class="hero features bg-white text-center"
    *ngIf="currentSection === 0"
  >
    <div class="container">
      <article class="loa-thanh-toan">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/b436d28e83be10ba661e3b0443901f47d1eac3675cfcb0e2067e937dd00ea8fa?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
          alt="Loa thanh toán"
          class="product-image-1"
        />
        <section class="content">
          <header>
            <h1 class="title">Loa thanh toán MB</h1>
            <p class="subtitle">Ting ting vào ví - Buôn bán như ý</p>
          </header>
          <p class="description text-center">
            Loa thông báo tiền về giúp người bán hàng xác nhận thanh toán
            <span class="highlight">nhanh chóng, an toàn</span> mà không cần
            kiểm tra điện thoại
          </p>
        </section>
        <button
          class="listen-button"
          [ngClass]="{ playing: isPlaying }"
          (click)="playAudio()"
        >
          <img
            loading="lazy"
            [src]="
              isPlaying
                ? 'https://cdn.builder.io/api/v1/image/assets/TEMP/73a4d5b7674bd782f322781ffb0a0975f4e938cdd00fb12a49694fe07a1372d4?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb'
                : 'https://cdn.builder.io/api/v1/image/assets/TEMP/6d87a1901c603907f22af955c5a7df72557bc9246325c9f0166e9cfbb386a10e?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb'
            "
            alt=""
            class="button-icon"
          />
          <span class="button-text">{{
            isPlaying ? "Đang phát" : "Nghe thử"
          }}</span>
        </button>
      </article>

      <div class="row my-2">
        <div class="col-6 col-md-3">
          <div class="bg-light text-left pl-2 p-1 rounded-3">
            <div class="mb-2">
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/e3344d125c957e4d301974b23b3ba4ce42b758686227cee4faee35d2022ea143?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt="Information icon"
                class="icon-image"
              />
            </div>
            <p class="fw-bold text-primary m-0">
              <span class="font-size-24">0</span> đồng
            </p>
            <p class="small text-black">Phí mua thiết bị</p>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="bg-light text-left pl-2 p-1 rounded-3">
            <div class="mb-2">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/a994e68677042cc1ae8fd5df93379a3df38eb1f749c2947b656131e373f2b15c?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="feature-icon"
              />
            </div>
            <p class="fw-bold text-primary m-0">
              <span class="font-size-24">1</span> đổi
              <span class="font-size-24">1</span>
            </p>
            <p class="small text-black">Bảo hành trọn đời</p>
          </div>
        </div>
        <div class="col-6 col-md-3 mt-3 mt-md-0">
          <div class="bg-light text-left pl-2 p-1 rounded-3">
            <div class="mb-1">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/58cb95ee3147b096fc32f4983a6c9097189d357b2ec7d4399265ab955c8d6d6f?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="feature-icon"
              />
            </div>
            <p class="fw-bold text-primary m-0">
              <span class="font-size-24">2</span> ngày pin
            </p>
            <p class="small text-black mb-1">
              Dùng thoải mái, <br />
              không lo ngắt quãng
            </p>
          </div>
        </div>
        <div class="col-6 col-md-3 mt-3 mt-md-0">
          <div class="bg-light text-left pl-2 p-1 rounded-3">
            <div class="mb-2">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/9bfdaf08a64f7466d42127639c086623929c75230769bd25e889ba4b27f1d992?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="feature-icon"
              />
            </div>
            <p class="fw-bold text-primary m-0">
              <span class="font-size-24">3</span> bước
            </p>
            <p class="small text-black m-0" style="line-height: revert">
              &nbsp; <br />
              Đăng ký và nhận loa
            </p>
          </div>
        </div>
      </div>

      <button
        class="btn-viettel rounded-pill fixed-button"
        (click)="nextSection()"
      >
        Nhận loa miễn phí
      </button>
    </div>
  </section>

  <section
    class="hero features pt-3 pb-5 bg-white text-center"
    style="height: 100vh"
    *ngIf="currentSection === 1"
  >
    <section class="container content-wrapper">
      <div class="text-left mb-3">
        <h2 class="ms-2 mb-2 fw-bold">Lựa chọn loại loa</h2>
        <p class="ms-2 mb-0">Vui lòng chọn loại loa và số lượng</p>
      </div>

      <ng-container *ngFor="let product of products">
        <article
          class="card-product col-12 col-md-4"
          [class.active]="activeProduct?.name === product.name"
          [class.bg-light]="product.name === '4g_old'"
          [ngStyle]="{ opacity: product.name === '4g_old' ? '0.5' : '1' }"
          (click)="
            product.name === 'wifi' || product.name === '4g'
              ? setActiveProduct(product)
              : null
          "
        >
          <div class="product-content">
            <img
              (click)="selectProduct(product)"
              loading="lazy"
              [src]="product.src"
              alt="{{ product.name }} product image"
              class="product-image img-fluid"
            />
            <div class="product-details">
              <h2 class="product-title">
                {{ product.name === "wifi" ? "Loa Wifi" : "Loa 4G" }}
              </h2>
              <p class="product-description">
                {{
                  product.name === "wifi"
                    ? "Loa sử dụng kết nối wifi"
                    : "Loa
                kết nối sim 4G "
                }}
              </p>

              <p class="product-accessories">
                {{
                  product.name === "wifi"
                    ? "Phụ kiện gồm dây sạc type C và
                bảng mã QR"
                    : "Phụ kiện gồm dây sạc type C, bảng mã QR, sim 4G
                đã kích hoạt"
                }}
              </p>
            </div>
          </div>
          <div
            class="quantity-stepper"
            *ngIf="activeProduct?.name === product.name"
          >
            <button
              class="stepper-button"
              aria-label="Decrease quantity"
              (click)="
                changeQuantity(selectedProduct, -1); $event.stopPropagation()
              "
              [disabled]="quantities[product.name] === 1"
            >
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/a6eb9af969ef8b6732e8769fbb384f8b17f21d751bb1d9649a679ff48a7443f6?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="stepper-icon"
              />
            </button>

            <input
              type="number"
              class="quantity-amount"
              [value]="selectedProduct?.quantity"
              aria-live="polite"
              readonly
              min="1"
              max="10"
            />

            <button
              class="stepper-button"
              aria-label="Increase quantity"
              (click)="
                changeQuantity(selectedProduct, 1); $event.stopPropagation()
              "
              [disabled]="quantities[product.name] >= 10"
            >
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/911a195508de5b43dfdef0a1906ef43fe9643542e750eff09f24c302715fd761?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="stepper-icon"
              />
            </button>
          </div>
          <div
            class="checkbox-container"
            *ngIf="activeProduct?.name === product.name"
          >
            <input
              type="checkbox"
              class="checkbox"
              [checked]="activeProduct?.name === product.name"
              (change)="onCheckboxChange($event)"
            />
          </div>
          <div class="product-old" *ngIf="product.name === '4g_old'">
            <span class="badge-text">Hết hàng</span>
          </div>
          <div class="product-badge" *ngIf="product.name === '4g'">
            <span class="badge-icon" aria-hidden="true">🔥</span>
            <span class="badge-text">New</span>
          </div>
        </article>
      </ng-container>

      <button
        class="btn-viettel rounded-pill fixed-button"
        (click)="saveToLocalStorage()"
        [disabled]="!activeProduct"
      >
        Tiếp tục
      </button>
    </section>
  </section>

  <section
    class="container content-wrapper px-3 pt-3 pb-5 bg-white text-center"
    style="height: 100vh"
    *ngIf="currentSection === 2"
  >
    <div class="text-left">
      <h1 class="h3 fw-bold">Chọn gói dịch vụ loa</h1>
      <p class="m-0 font-size-15">
        Nhận ngay loa thanh toán miễn phí khi đăng ký gói dịch vụ
      </p>
    </div>
    <section class="offer-container my-3 text-left">
      <h2 class="offer-text">🔥 Ưu đãi siêu hấp dẫn chỉ trong tháng 2</h2>
    </section>
    <div class="plan-cards-container">
      <article
        class="plan-card border"
        [class.popular]="item.tag === 'Phổ biến nhất'"
        [class.best-value]="item.tag === 'Tiết kiệm nhất'"
        [class.selected]="selectedPackageId === item.id"
        *ngFor="let item of packages"
        (click)="selectPackage(item.id)"
      >
        <div class="plan-content">
          <h2 class="plan-duration">{{ item.original_duration }} tháng</h2>
          <p class="plan-feature">{{ item.benefit }}</p>
          <p class="plan-bonus">
            Tặng thêm
            <span class="bonus-months">
              {{
                item.original_duration === 3
                  ? 1
                  : item.original_duration === 6
                  ? 3
                  : 5
              }}
              tháng
            </span>
          </p>
        </div>
        <div class="plan-pricing">
          <div class="original-price-container">
            <span class="original-price"
              >{{ item.original_price | number : "1.0-0" }} VND
            </span>
            <div class="strike-through"></div>
          </div>
          <span class="discounted-price"
            >{{ item.discounted_price | number : "1.0-0" }} VND
          </span>
          <span class="price-per-month"
            >({{ item.price_per_month | number : "1.0-0" }} VND /tháng)</span
          >
        </div>
        <span *ngIf="item.tag === 'Phổ biến nhất'" class="popular-tag"
          >Phổ biến nhất</span
        >
        <span *ngIf="item.tag === 'Tiết kiệm nhất'" class="best-value-tag"
          >Tiết kiệm nhất</span
        >
      </article>
    </div>
    <div class="text-left mb-3">
      <span style="font-size: 0.8rem"
        ><span style="color: red; font-weight: bold">*</span>Giá các gói dịch vụ
        đã bao gồm VAT
      </span>
    </div>
    <!-- <section class="d-flex flex-column">
      <div
        style="width: fit-content;"
        class="d-flex align-items-center justify-content-start px-1 py-1 font-weight-bold text-uppercase text-white bg-danger rounded-pill"
      >
        <span class="my-auto">🔥</span>
        <span class="my-auto">Ưu đãi thêm từ MB</span>
      </div>
      <p
        class="mt-1 text-muted text-left"
        style="font-size: 0.8rem; margin-bottom: 0.5rem;"
      >
        Tặng thêm đến
        <strong class="font-weight-bold text-primary">3 tháng</strong> sử dụng
        loa khi duy trì số tiền trung bình trong tài khoản tối thiểu
        <strong class="font-weight-bold text-primary"
          >20 triệu đồng/tháng</strong
        >
      </p>
    </section> -->

    <button
      class="btn-viettel fixed-button rounded-pill"
      data-bs-toggle="modal"
      data-bs-target="#chooseModal"
      (click)="registerService()"
      [disabled]="!selectedPackageId"
    >
      Đăng ký
    </button>
  </section>
</div>

<div
  #chooseModal
  class="modal fade bottom-modal mw-100"
  id="chooseModal"
  tabindex="-1"
  aria-labelledby="chooseModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-bottom">
    <div class="modal-content" style="border-radius: 1rem">
      <section class="delivery-modal">
        <header class="delivery-header">
          <h2 class="delivery-title">Phương thức nhận loa</h2>
          <button
            class="close-button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            aria-label="Close modal"
          ></button>
        </header>
        <main>
          <article class="delivery-option" (click)="handleOnline()">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/d5ddc7d49adae6d782c3e6383b3a0c695de33f8f6a43985661d634791d57fdbd?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
              alt="Home delivery icon"
              class="delivery-icon"
            />
            <div class="delivery-content">
              <h3 class="option-title">Đặt Loa giao về nhà</h3>
              <p class="option-description">
                Nhận Loa từ đơn vị vận chuyển sau 3-7 ngày làm việc.
              </p>
            </div>
            <button class="select-button" aria-label="Select home delivery">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/07b16527e898bdace02592175e1a33e854506ff0399a1d376dd4028fb25fc4b0?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="select-icon"
              />
            </button>
          </article>
          <article
            class="delivery-option"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="openDirectModal()"
          >
            <i class="ri-group-line custom-icon"></i>
            <div class="delivery-content">
              <h3 class="option-title">Đã nhận Loa trực tiếp</h3>
              <p class="option-description text-danger">
                Nếu quý khách đã nhận Loa từ nhân viên.
              </p>
            </div>
            <button class="select-button" aria-label="Select direct delivery">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/07b16527e898bdace02592175e1a33e854506ff0399a1d376dd4028fb25fc4b0?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="select-icon"
              />
            </button>
          </article>
        </main>
      </section>
    </div>
  </div>
</div>

<div
  #chooseDetails
  class="modal fade"
  id="chooseDetails"
  tabindex="-1"
  aria-labelledby="chooseDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-bottom">
    <div class="delivery-modal">
      <header class="delivery-header">
        <h2 class="delivery-title text-capitalize">
          {{ selectedProduct?.name === "wifi" ? "Loa WIFI" : "Loa 4G" }}
        </h2>
        <button
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </header>
      <main class="text-center">
        <div class="image-container">
          <img
            [src]="selectedProduct?.src"
            alt="Loa Wifi device"
            class="product-image-modal"
          />
        </div>
        <h3 class="product-title mb-3">
          {{ selectedProduct?.name === "wifi" ? "Loa WIFI" : "Loa 4G" }}
        </h3>
        <p>
          {{
            selectedProduct?.name === "wifi"
              ? "Loa sử dụng kết nối wifi"
              : "Loa kết nối sim 4G"
          }}
        </p>
        <p>
          {{
            selectedProduct?.name === "wifi"
              ? "Phụ kiện gồm dây sạc type C và
          bảng mã QR"
              : "Phụ kiện gồm dây sạc type C, bảng mã QR, sim 4G đã kích
          hoạt"
          }}
        </p>
      </main>
    </div>
  </div>
</div>
<!-- <div *ngIf="isCancelModalOpen" class="modal-overlay">
  <div class="modal-content-verified">
    <div class="modal-icon">
      <img
        style="width: 90px; height: 90px;"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/1e2e3510eec4e651f45376fbe897ac8a40e1c048d47f9502e2540cc469f3da88?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
        alt="Cancel order icon"
        class="cancel-icon"
      />
    </div>
    <div class="m-header">Đặt Loa giao về nhà</div>
    <div class="m-body">
      Do ảnh hưởng của việc giao hàng vào dịp <span class="text-danger">Tết nguyên đán</span>, đơn hàng của Quý khách sẽ được giao vào ngày <span class="text-danger"> 10/02 – 16/02</span>.
    </div>
    <div class="d-flex flex-column">
      <button
        (click)="handleOnline()"
        
        class="confirm-button w-100 mb-2"
      >
      Tiếp tục
      </button>
      <button
        (click)="closeCancelModal()"
     
        class="back-button w-100"
      >
        Quay lại
      </button>
    </div>
  </div>
</div> -->

<div *ngIf="isDirectModalOpen" class="modal-overlay">
  <div class="modal-content-verified">
    <div class="modal-icon">
      <img
        style="width: 90px; height: 90px"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/1e2e3510eec4e651f45376fbe897ac8a40e1c048d47f9502e2540cc469f3da88?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
        alt="Cancel order icon"
        class="cancel-icon"
      />
    </div>
    <div class="m-header">Đã nhận Loa trực tiếp</div>
    <div class="m-body">
      Vui lòng chỉ chọn <span class="text-danger">“Tiếp tục”</span> khi đã nhận
      được Loa thanh toán MB từ nhân viên. Nếu chưa,
      <span class="text-danger">“Quay lại”</span> để đặt giao Loa về nhà
    </div>
    <div class="d-flex flex-column">
      <button (click)="handleOffline()" class="confirm-button w-100 mb-2">
        Tiếp tục
      </button>
      <button (click)="closeDirectModal()" class="back-button w-100">
        Quay lại
      </button>
    </div>
  </div>
</div>
